import axios from 'axios';

function resolveApiUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:5003/api';
    return `${window.location.origin}/api`;
  }
  return 'https://gastoscomunes.sistemasoh.cl/api';
}

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gc_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function login(email, password) {
  const { data } = await api.post('/usuarios/login', { email, password });
  if (data.token) {
    localStorage.setItem('gc_token', data.token);
  }
  return data;
}

export function logout() {
  localStorage.removeItem('gc_token');
  localStorage.removeItem('gc_condominio_id');
}

export async function fetchGcMe() {
  const { data } = await api.get('/gastos-comunes/me');
  return data;
}

export default api;
